import React from 'react';
import { useAdministrationOverlay } from '@piwikpro/router-crate';
import Rename from './Rename';
import AddApps from './AddApps';

interface MetaSiteDetailsOverlayProps {
  appsInsidePaginationLimit: number
}

/** Details-scoped overlays; hosted here so metaSite is already loaded. */
const MetaSiteDetailsOverlay: React.FC<MetaSiteDetailsOverlayProps> = ({
  appsInsidePaginationLimit,
}) => {
  const overlay = useAdministrationOverlay();

  if (overlay === '/m/rename') {
    return <Rename />;
  }

  if (overlay === '/o/add-apps') {
    return <AddApps appsInsidePaginationLimit={appsInsidePaginationLimit} />;
  }

  return null;
};

export default MetaSiteDetailsOverlay;
